import { Avatar } from '@eye-able/ui';
import { cn } from '@helpers/cn';
import { UserRoundX } from 'lucide-react';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

/**
 * Avatar for a user that cannot be resolved.
 *
 * Its image role and accessible name make the icon understandable to assistive
 * technologies wherever it is used.
 */
export function UnknownUserAvatar({ className }: { className?: string }) {
  const { t } = useInlineTranslation();

  return (
    <Avatar
      role='img'
      aria-label={t('unknownUser')}
      className={cn('eye:bg-grey-20 eye:shrink-0', className)}
    >
      <UserRoundX size={24} aria-hidden />
    </Avatar>
  );
}
